module.exports = __webpack_public_path__ + "img/sld_mfm_invs_10_dark.786d99c7.svg";